import { createRoutesFromElements, defer, Navigate, Route } from "react-router";
import "./App.css";
import GiftPage from "./views/GiftsPage";
import Home from "./views/Home";
import LoginPage from "./views/LoginPage";
import PointsReview from "./views/PointsReview";
import SignupForm from "./views/SignUpPage";
import QrCodeScannerPage from "./views/QrCodeScannerPage";
import "./i18next";
import ProfilePage from "./views/ProfilePage";
import AdminHome from "./views/admin/AdminHome";
import AdminUsers from "./views/admin/AdminUsers";
import AdminGifts from "./views/admin/AdminGifts";
import AdminReceiptsProcessing from "./views/admin/AdminReceiptsProcessing";
import AdminSettings from "./views/admin/AdminSettings";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import { createBrowserRouter } from "react-router-dom";
import { AuthLayout } from "./components/AuthLayout";
import store from "./redux/store";
import { checkCurrentUserExists } from "./redux/slices/authenticationSlice";
import { ProtectedRouteAdmin } from "./routes/ProtectedRouteAdmin";
import AdminReports from "./views/admin/AdminReports";
import AdminSendingGifts from "./views/admin/AdminSendingGifts";

const getUserData = () =>
  new Promise((resolve) => {
    const user = store.dispatch(checkCurrentUserExists()).then((response) => {
      return response;
    });
    resolve(user);
  });

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={() => defer({ userPromise: getUserData() })}
    >
      <Route path="/login" element={<LoginPage />}></Route>
      <Route path="/sign-up" element={<SignupForm />}></Route>
      <Route
        path="/home"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      >
        <Route
          path="/home/points"
          element={
            <ProtectedRoute>
              <PointsReview />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/home/gift-page"
          element={
            <ProtectedRoute>
              <GiftPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/home/qr-code-scanner"
          element={
            <ProtectedRoute>
              <QrCodeScannerPage />
            </ProtectedRoute>
          }
        ></Route>
        <Route
          path="/home/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        ></Route>
      </Route>
      <Route
        path="/admin"
        element={
          <ProtectedRouteAdmin>
            <AdminHome />
          </ProtectedRouteAdmin>
        }
      >
        <Route
          path="/admin/users"
          element={
            <ProtectedRouteAdmin>
              <AdminUsers />
            </ProtectedRouteAdmin>
          }
        ></Route>
        <Route
          path="/admin/settings"
          element={
            <ProtectedRouteAdmin>
              <AdminSettings />
            </ProtectedRouteAdmin>
          }
        ></Route>
        <Route
          path="/admin/gifts"
          element={
            <ProtectedRouteAdmin>
              <AdminGifts />
            </ProtectedRouteAdmin>
          }
        ></Route>
        <Route
          path="/admin/receipts-processing"
          element={
            <ProtectedRouteAdmin>
              <AdminReceiptsProcessing />
            </ProtectedRouteAdmin>
          }
        ></Route>
        <Route
          path="/admin/reports"
          element={
            <ProtectedRouteAdmin>
              <AdminReports />
            </ProtectedRouteAdmin>
          }
        ></Route>
        <Route
          path="/admin/sending-gifts"
          element={
            <ProtectedRouteAdmin>
              <AdminSendingGifts />
            </ProtectedRouteAdmin>
          }
        ></Route>
      </Route>
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Route>
  )
);
